import { render } from "./TelIcon.vue?vue&type=template&id=82589c6a"
import script from "./TelIcon.vue?vue&type=script&lang=js"
export * from "./TelIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__